import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';
import { ClientBadgesState } from '@/types/updates-hub';

class ClientBadgesService {
  async getClientBadges(clientId: number): Promise<ClientBadgesState> {
    const response = await api.get<ApiResponse<ClientBadgesState>>(`/clients/${clientId}/badges`);
    return unwrapApiResponse<ClientBadgesState>(response);
  }
}

export const clientBadgesService = new ClientBadgesService();
